import { getEmissionCategoryRepository } from "../Infrastructure/EmissionCategory.repository";

export async function getEmissionCategoryLogic() {
  return getEmissionCategoryRepository();
}
